/**
 * Read a server-supplied message off a rejected API call.
 *
 * The app talks to the backend through two clients: axios (`error.response.data`)
 * and the fetch wrapper in lib/api.ts (`error.responseData`). Reading only the
 * axios shape silently drops the server's message for every fetch-client call —
 * which is how a 409 explaining why a distributor cannot be deleted surfaced as
 * a bare "Failed to delete distributor".
 */
export function extractApiError(error: unknown, fallback: string): string {
  const data = (error as any)?.response?.data ?? (error as any)?.responseData;
  return data?.error || data?.detail || (error as any)?.message || fallback;
}
